/* eslint-disable react-refresh/only-export-components */
import { useEffect } from 'react';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { connect } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { useDeepMerge } from '@/hooks/useDeepMerge';
import ApplyTheme from '@/components/v4/Theme/ApplyTheme';
import { router } from '@tcap/data-router/router';
import { traceBoot } from '@tcap/data-router/utils/bootTrace';
import { queryClient } from '@tcap/data-router/utils/queryClient';
import { loadUsetifulScript } from 'usetiful-sdk';

import '@/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const USETIFUL_SPACE_TOKEN = '6b2eeffa529e5e9b67c90a298fbc8706';
let hasLoggedDataRouterRender = false;

traceBoot('data-router.module');

function App() {
    const { theme, chakratheme } = useDeepMerge();

    if (!hasLoggedDataRouterRender) {
        hasLoggedDataRouterRender = true;
        traceBoot('data-router.render');
    }

    useEffect(() => {
        traceBoot('data-router.mount');
    }, []);

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;

        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get('perf') === '1') return undefined;

        const loadScript = () => loadUsetifulScript(USETIFUL_SPACE_TOKEN);

        if ('requestIdleCallback' in window) {
            const idleId = window.requestIdleCallback(loadScript, {
                timeout: 2000,
            });
            return () => window.cancelIdleCallback(idleId);
        }

        const timeoutId = window.setTimeout(loadScript, 0);
        return () => window.clearTimeout(timeoutId);
    }, []);

    return (
        <ChakraProvider theme={theme}>
            <ApplyTheme>
                <QueryClientProvider client={queryClient}>
                    <RouterProvider router={router} />
                    <ColorModeScript
                        initialColorMode={chakratheme.config.initialColorMode}
                        theme={chakratheme}
                    />
                    <ReactQueryDevtools
                        initialIsOpen={false}
                        position="bottom-right"
                    />
                </QueryClientProvider>
            </ApplyTheme>
        </ChakraProvider>
    );
}

const MainApp = connect()(App);
export default MainApp;
